import axios from 'axios'

import store from '../../store/configureStore'
import { RESET } from '../../store/rootReducer'
import history from '../routing/history'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  timeout: 60000,
})

const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }

  const {
    currentUser: { user },
  } = store.getState()

  if (user && user.token) {
    headers.Authorization = user.token
  }

  return { headers }
}

const handleError = ({ response, request: { status } }) => {
  if (status === 401 || status === 403) {
    store.dispatch({ type: RESET })
    history.push('/login')
  }
  if (!response || !response.data || !response.data.error) {
    throw new Error('Something went wrong. Please try again.')
  }
  throw new Error(response.data.error.message)
}

const get = (path, params) =>
  axiosInstance
    .get(path, Object.assign({}, { params }, getHeaders()))
    .then(response => response.data)
    .catch(handleError)

const patch = (path, data) =>
  axiosInstance
    .patch(path, data, Object.assign({}, getHeaders()))
    .then(response => response.data)
    .catch(handleError)

const post = (path, data) =>
  axiosInstance
    .post(path, data, Object.assign({}, getHeaders()))
    .then(response => response.data)
    .catch(handleError)

const del = path =>
  axiosInstance
    .delete(path, Object.assign({}, getHeaders()))
    .then(response => response.data)
    .catch(handleError)

export default {
  get,
  patch,
  post,
  del,
  handleError,
  axiosInstance,
}



// WEBPACK FOOTER //
// ./src/utils/http/api.js